import BackgroundVideo from './BackgroundVideo';
import Vault from './Vault';
import WarningBar from './WarningBar';
import OnboardingProjectSequence from './project-owner/OnboardingProjectSequence';
import LogoBarStatic from './LogoBarStatic';
import { FC } from 'react';

const OnboardingProject: FC = () => {
  return (
    <div className="grid w-full h-full place-content-center">
      <BackgroundVideo />
      <Vault fadeInImmediately />

      <div className="grid grid-rows-[auto_auto_1fr] gap-[8px] absolute top-0 left-0 w-screen h-full text-center justify-center">
        <WarningBar />
        <LogoBarStatic />
        <OnboardingProjectSequence />
      </div>
    </div>
  );
};

export default OnboardingProject;
